import { render, staticRenderFns } from "./ThirdPartyServiceConfigEditor.vue?vue&type=template&id=2c9120f2&"
import script from "./ThirdPartyServiceConfigEditor.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyServiceConfigEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports